import CounterAnimation from '../../../utils/CounterAnimation';

class Bsuite {
  constructor() {
    this.main = document.getElementById('bsuite');

    // Inicializo CounterAnimation
    setTimeout(()=>{
      CounterAnimation.init();
    }, 0);
  }
}

export default Bsuite;